(function AgentWebsitesIndex($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('main/index', function onload()
		{
			var $homepage_popup = $('div#homepage_popup.modal'),
			    viewed_banners  = [];

			var _updateBannerViews;

			if ($homepage_popup.length) {
				$homepage_popup.modal();
			}

			Adzuki.Typeahead(
				'.where-in-the-world',
				'/Cities/search',
				function select(item) {
					$('#whereintheworld-city_id').val(item.id);
				},
				function template(item) {
					var html = '';

					if (item.name !== null) {
						html += item.name;
					}

					if (item.state !== null) {
						html += ', ' + item.state;
					}

					if (item.country !== null) {
						html += ', ' + item.country;
					}

					return html;
				}
			);

			/* Adzuki.Typeahead(
				'#clublife-club',
				'/main/clubLifeSearch',
				function select(item) {
					document.location = Adzuki.base_uri + '/main/setClub/' + item.id;
				},
				function template(item) {
					var html = '';

					if (item.name !== null) {
						html += item.name;
					}

					return html;
				}
			); */

			_updateBannerViews = function _updateBannerViews(local_id)
			{
				var id = local_id.replace("banner-", "");

				if (viewed_banners.indexOf(id) !== -1) {
					return;
				}

				Adzuki.Ajax.get('/WebsiteBanners/updateViews/' + id).then(function success(response) {
					// console.log("viewed " + id);

					viewed_banners.push(id);
				});
			};

			_updateBannerViews($($('.carousel-inner').find('.item')[0]).attr('id'));

			$("#travel-deals").on('slid.bs.carousel', function slidIt(e) {
				_updateBannerViews(e.relatedTarget.id);
			});

			Adzuki.Typeahead(
				'#signature_offer_code',
				'/Searches/signatureCodeSearch',
				function select(item) {
					if (item.url_key) { // this is when tied to a deal
						document.location = Adzuki.base_uri + '/deals/view/' + item.url_key;
					} else if (item.id === 'fail') {
						Adzuki.StatusMessage('Error', 'Sorry, the code you entered is not valid. Please enter a different code.', 'Invalid Code');
						$('#signature_offer_code').val('');
					} else if (item.name.length > 0) { // this is when it's just designed for a modal 
						Adzuki.Ajax.get('/CruiseSearch/offerDetails/' + item.id)
							.then(function populateModal(content) {
								$(".modal-dialog").addClass('modal-lg');
								$(".modal-title").text(item.consumer_title);
								$('.modal-body').html(content);
						});

						$('.modal').modal('show');
					}
				},
				function template(item) {
					var html = '';

					if (item.consumer_title === null || item.consumer_title.length === 0) {
						if (item.company === null) {
							html += item.offer_name;
						} else {
							html += item.company + ': ' + item.offer_name;
						}
					} else {
						if (item.company === null) { // eslint-disable-line no-lonely-if
							html += item.consumer_title;
						} else {
							html += item.company + ': ' + item.consumer_title;
						}
					}

					return html;
				}
			);
		});

		$('.where-in-the-world-go').click(function goToCity() {
			$('#where-in-the-world-form').submit();
		});

		$('.cp-icon-times-thin').click(function closeSearchBar(e) {
			e.preventDefault();
			$('.search-sticky').hide();
		});

		$('.contact-head .close').click(function closeContactBar(e) {
			e.preventDefault();
			$('.contact').hide();
		});

		$('.offer-item').click(function offerClick(e) {
			e.preventDefault();

			if ($(this).data('type') === 'website_offers') {
				Adzuki.Ajax.get('/WebsiteOffers/updateClicks/' + $(this).data('id')).then(function success(response) {
					console.log("clicked");
				});
			}

			if ($(this).data('open-new-window') === 'Y') {
				window.open($(this).data('url'), '_blank');
			} else {
				document.location = $(this).data('url');
			}
		});

		$('.load-more').click(function showHideMoreOffers() {
			if ($('.more-offers').css('display') === 'none') {
				$('.more-offers').slideDown();
				$(this).html('<i class="'+Adzuki.FaIcon.getIconStyle('ignore')+'"></i>Hide More Offers');
			} else {
				$('.more-offers').slideUp();
				$(this).html('<i class="'+Adzuki.FaIcon.getIconStyle('add')+'"></i>Load More Offers');
			}
		});

		$('.set-clublife-club').click(function setClubLifeClub() {
			var clublife_club = $('#clublife-club').val();

			if (clublife_club === '') {
				Adzuki.StatusMessage(null, 'Please choose a club from the list', 'No Club Selected');
			} else {
				window.location.href = Adzuki.base_uri + '/main/setClub/' + clublife_club;
			}
		});

		$('.agent-card').click(function triggerAboutUs() {
			window.location.href = Adzuki.base_uri + '/WebsitePages/about';
		});

		$('.mobile-header').click(function showOptions() {
			if ($('.mobile-header-options').hasClass('hidden') === true) {
				$('.mobile-header-options').removeClass('hidden');
				$(this).html('Hide Search');
			} else {
				$('.mobile-header-options').addClass('hidden');
				$(this).html('Click Here to Search for Travel');
			}
		});
	});
}(jQuery, window.Adzuki || {}));
